import moment from "moment";
import { maxLength, required, requiredUnless } from "vuelidate/lib/validators";
import { INFO_STATUS_TYPES } from "@/constants";
import { BaseModel } from "@/models/BaseModel";
import { Activity } from "@/models/Activity";
import { Checkstatus } from "@/models/Checkstatus";
import { Document } from "@/models/Document";
import { InfoCategory } from "@/models/InfoCategory";
import { Person } from "@/models/Person";
import { User } from "@/models/User";
import { UserGroup } from "@/models/UserGroup";
import { Company } from "@/models/Company";
import { Tag } from "@/models/Tag";
import Department from "./Department";
import Signature from "./Signature";
import store from '@/store';
import { Protocol } from "./Protocol";
import { INFO_TYPES } from "@/constants";


export class Info extends BaseModel {
  constructor({
    id = null,
    name,
    content = "<p></p>",
    content_new,
    content_old,
    info_type,
    status = INFO_STATUS_TYPES.DRAFT,
    creation_date,
    deadline_date,
    latest_change,
    approved_timestamp,
    completed_timestamp,
    category = null,
    category2 = null,
    creator,
    company,
    department,
    version = "1",
    responsible,
    only_visible_for_admins = false,
    activities = [],
    activity_count = 0,
    activity_done_count = 0,
    documents = [],
    parent = null,
    children = [],
    children_protocol = [],
    answer_siblings = [],
    origin = null,
    links = [],
    siblings = [],
    language,
    viewed,
    signed,
    signatures = [],
    signature_count,
    signature_approved_count,
    signature_rejected_count,
    next_version = null,
    previous_version = null,
    version_changelog,
    company_template,
    focus_areas = [],
    field1,
    field2,
    field3,
    field4,
    field5,
    field6,
    field7,
    field8,
    visible_to = [],
    visible_to_user_groups = [],
    visible_to_departments = [],
    editable_for = [],
    editable_for_user_groups = [],
    editable_for_departments = [],
    can_edit = false,
    readreceipt_active = false,
    readreceipt_active_for_user = false,
    readreceipt_individual = [],
    readreceipt_user_groups = [],
    readreceipt_departments = [],
    checkstatuses = [],
    field9,
    field10,
    field11, //Default
    field12, //Sustainability report comment
    field13, //Reviewed signature
    field14, //visable for children
    field15, //cooperation
    field16, //signature
    field17, //links
    field18, //Status history
    field19, //Only use template info
    field20, //template id
    field21, //AEO meta data 1
    field22, //AEO meta data 2
    field23, //AEO meta data 3
    field24, //AEO meta data 4
    field25, //AEO meta data 5
    field26,
    field27,
    field28,
    field29,
    field30,
    role_competencies = [],
    persons = [],
    external_url,
    prio,
    tags = [],
    esrstags = [],
    esrs_comment,
    esrs_report,
    esrs_control,
    next_deadline_date,
    next_deadline_date2,
    reminder_days_ahead = 30,
    video_content,
    help_text = null,
    view_count = 0,
  }) {
    super();
    this.id = id;
    this.name = name;
    this.content = content;
    this.content_old = content_old;
    this.content_new = content_new;
    this.info_type = info_type;
    this.status = status;
    this.creation_date = moment(creation_date);
    this.latest_change = moment(latest_change);
    this.deadline_date = deadline_date;
    this.approved_timestamp = approved_timestamp ? moment(approved_timestamp) : null;
    this.completed_timestamp = completed_timestamp ? moment(completed_timestamp) : null;
    this.category = category ? new InfoCategory(category) : null;
    this.category2 = category2 ? new InfoCategory(category2) : null;
    this.creator = creator ? new User(creator) : null;
    this.company = company ? new Company(company) : null;
    this.department = department ? new Department(department) : null;
    this.responsible = responsible ? new Person(responsible) : null;
    this.only_visible_for_admins = only_visible_for_admins;
    this.activities = activities.map((a) => new Activity(a));
    this.activity_count = activity_count;
    this.activity_done_count = activity_done_count;
    this.documents = documents.map((d) => new Document(d));
    this.version = version;
    this.parent = parent ? parent : null;
    this.children = children.map((i) => new Info(i));
    this.children_protocol = children_protocol.map((p) => new Protocol(p));
    this.answer_siblings = answer_siblings;
    this.origin = origin ? origin : null;
    this.links = links.map((i) => new Info(i));
    this.siblings = siblings.map((i) => new Info(i));
    this.persons = persons.map((p) => new Person(p));
    this.language = language;
    this.viewed = viewed;
    this.signed = signed;
    this.signatures = signatures.map((s) => new Signature(s));
    this.signature_count = signature_count;
    this.signature_approved_count = signature_approved_count;
    this.signature_rejected_count = signature_rejected_count;
    this.next_version = next_version;
    this.previous_version = previous_version;
    this.version_changelog = version_changelog;
    this.company_template = company_template;
    this.focus_areas = focus_areas;
    // Generic fields...
    this.field1 = field1;
    this.field2 = field2;
    this.field3 = field3;
    this.field4 = field4;
    this.field5 = field5;
    this.field6 = field6;
    this.field7 = field7;
    this.field8 = field8;
    this.visible_to = visible_to;
    this.visible_to_user_groups = visible_to_user_groups ? visible_to_user_groups.map((g) => new UserGroup(g)) : [];
    this.visible_to_departments = visible_to_departments ? visible_to_departments.map((d) => new Department(d)) : [];
    this.editable_for = editable_for;
    this.editable_for_user_groups = editable_for_user_groups ? editable_for_user_groups.map((g) => new UserGroup(g)) : [];
    this.editable_for_departments = editable_for_departments ? editable_for_departments.map((d) => new Department(d)) : [];
    this.can_edit = can_edit;
    this.readreceipt_active = readreceipt_active;
    this.readreceipt_active_for_user = readreceipt_active_for_user;
    this.readreceipt_individual = readreceipt_individual;
    this.readreceipt_user_groups = readreceipt_user_groups;
    this.readreceipt_departments = readreceipt_departments;
    this.checkstatuses = checkstatuses ? checkstatuses.map((c) => new Checkstatus(c)) : [];
    this.field9 = field9;
    this.field10 = field10;
    this.field11 = field11;
    this.field12 = field12;
    this.field13 = field13;
    this.field14 = field14;
    this.field15 = field15;
    this.field16 = field16;
    this.field17 = field17;
    this.field18 = field18;
    this.field19 = field19;
    this.field20 = field20;
    this.field21 = field21;
    this.field22 = field22;
    this.field23 = field23;
    this.field24 = field24;
    this.field25 = field25;
    this.field26 = field26;
    this.field27 = field27;
    this.field28 = field28;
    this.field29 = field29;
    this.field30 = field30;
    this.role_competencies = role_competencies;
    this.external_url = external_url;
    this.prio = prio;
    this.tags = tags.map((x) => new Tag(x));
    this.esrstags = esrstags.map((x) => new Tag(x));
    this.esrs_comment = esrs_comment;
    this.esrs_report = esrs_report;
    this.esrs_control = esrs_control;
    this.next_deadline_date = next_deadline_date;
    this.next_deadline_date2 = next_deadline_date2;
    this.reminder_days_ahead = reminder_days_ahead;
    this.video_content = video_content;
    this.help_text = help_text;
    this.view_count = view_count;
  }

  static get validations() {
    const validations = {
      content: {},
      content_new: {},
      content_old: {},
      name: {
        maxLength: maxLength(250),
        required
      },
      responsible: {}
    };

    return validations;
  }

  get history() {
    if (this.field18) {
      return JSON.parse(this.field18);
    } else {
      return [];
    }
  }

  // Used in InfoFormEmployee to determine what type it is
  get employeeFollowUpType() {
    return this.field1;
  }
  set employeeFollowUpType(value) {
    this.field1 = value;
  }

  // Used in InfoFormEmployee to determine what persons that are connected
  get employeeConnectedEmployees() {
    return JSON.parse(this.field3);
  }
  set employeeConnectedEmployees(value) {
    this.field3 = JSON.stringify(value);
  }

  unsignedReadReceipt(user){
    return this.readreceipt_active && !this.signed && !user.isGuest;
  }

  // Checkstatus
  get hasCheckstatuses(){
    return this.checkstatuses.length > 0;
  }

  get hasCheckstatusQuestionnaire(){
    return this.checkstatuses.length > 0 && this.checkstatuses[0].questionnaire_id > 0;
  }

  // Info types
  get isProcessMap(){
    return this.info_type == INFO_TYPES.PROCESSMAP;
  }

  get isStakeholder(){
    return this.info_type == INFO_TYPES.STAKEHOLDER;
  }

  get isIsoRisk(){
    return this.info_type == INFO_TYPES.ISO_RISK;
  }

  get isAspect(){
    return this.info_type == INFO_TYPES.ANALYSIS;
  }

  get isLegal(){
    return this.info_type == INFO_TYPES.LEGAL || this.info_type == INFO_TYPES.LEGAL2;
  }

  get isSecurityMeasure(){
    return this.info_type == INFO_TYPES.INFORMATION_SECURITY_MEASURE;
  }

  get isGeneralDocument(){
    return this.info_type == INFO_TYPES.POLICY ||
           this.info_type == INFO_TYPES.ROUTINE ||
           this.info_type == INFO_TYPES.INSTRUCTION ||
           this.info_type == INFO_TYPES.GOAL ||
           this.info_type == INFO_TYPES.LEGAL2;
  }

  fieldsToTranslate(){
    if(this.isProcessMap){
      return {
        "name": this.name,
        "content": this.content,
        "esrs_control": this.esrs_control,
        "field3": this.field3,
        "field4": this.field4,
        "field8": this.field8,
        "field9": this.field9,
        "field21": this.field21,
        "field22": this.field22,
        "field23": this.field23,
        "field24": this.field24,
        "field25": this.field25,
        "help_text": this.help_text
      }
    }
    else if(this.isStakeholder){
      return {
        "name": this.name,
        "content": this.content,
        "esrs_control": this.esrs_control,
        "field5": this.field5,
        "field6": this.field6,
        "field7": this.field7,
        "field8": this.field8,
        "field9": this.field9,
        "field28": this.field28,
        "help_text": this.help_text
      }
    }
    else if(this.isIsoRisk){
        return {
          "name": this.name,
          "content": this.content,
          "esrs_control": this.esrs_control,
          "field2": this.field2,
          "field9": this.field9,
          "field10": this.field10,
          "help_text": this.help_text
        }
      }
    else if( this.isAspect){
      return {
        "name": this.name,
        "content": this.content,
        "esrs_control": this.esrs_control,
        "field23": this.field23,
        //"field24": this.field24,
        "field25": this.field25,
        "field27": this.field27,
        "field28": this.field28,
        "field29": this.field29,
        "help_text": this.help_text
      }
    }
    else if( this.isLegal){
      return {
        "name": this.name,
        "content": this.content,
        "esrs_control": this.esrs_control,
        "field1": this.field1,
        "field2": this.field2,
        "field3": this.field3,
        "field4": this.field4,
        "field6": this.field6,
        "field9": this.field9,
        "field23": this.field23,
        "field29": this.field29,
        "help_text": this.help_text
      }
    }
    else if( this.isSecurityMeasure){
      return {
        "name": this.name,
        "content": this.content,
        "field6": this.field6, // Summary
        "field7": this.field7, // Motivation
        "field9": this.field9, // Control
        "esrs_control": this.esrs_control,
        "help_text": this.help_text
      }
    }
    else if( this.isGeneralDocument){
      return {
        "name": this.name,
        "content": this.content,
        "help_text": this.help_text
      }
    }
  }
}

export default Info;
